import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  Form,
  Input,
  notification,
  Select,
  DatePicker,
} from "antd";
import moment from "moment";
import axios from "axios";
import styled from "styled-components";

const { Option } = Select;

const StyledDatePicker = styled(DatePicker)`
  width: 100%;
`;

const CreateEvent = (props) => {
  const { setDrawerVisibility, setRefetch, rowData } = props;
  console.log(rowData);
  const [btnLoading, setBtnLoading] = useState(false);
  const [allEventTypes, setAllEventTypes] = useState(null);
  const [allGroups, setAllGroups] = useState(null);
  const [startDate, setStartDate] = useState({});
  const [endDate, setEndDate] = useState({});

  useEffect(() => {
    fetch("/api/Event/GetEventTypes")
      .then((res) => res.json())
      .then((data) => {
        setAllEventTypes(data);
      })
      .catch((err) => {
        console.log(err.response);
        notification.error({
          message: "Unable to fetch event type",
          description: "",
        });
      });

    fetch("/api/Group/GetGroups")
      .then((res) => res.json())
      .then((data) => {
        setAllGroups(data);
      })
      .catch((err) => {
        console.log(err.response);
        notification.error({
          message: "Unable to fetch groups",
          description: "",
        });
      });
  }, []);

  const disabledEndDate = (current) => {
    return current && current < startDate;
  };

  const disabledStartDate = (current) => {
    return current && current > endDate;
  };

  const handleEventCreate = (values) => {
    const {
      name,
      groupId,
      eventTypeId,
      subdomain,
      startDateTime,
      endDateTime,
    } = values;
    setBtnLoading(true);
    let formData = new FormData();
    formData.append("Name", name);
    formData.append("GroupId", groupId);
    formData.append("EventTypeId", eventTypeId);
    formData.append("SubDomainIdentifier", subdomain);
    formData.append(
      "StartDateTime",
      startDateTime && moment(startDateTime).format("MM/DD/YYYY")
    );
    formData.append(
      "EndDateTime",
      endDateTime && moment(endDateTime).format("MM/DD/YYYY")
    );
    if(rowData) {
      formData.append("EventId", rowData.eventID);
    }
    axios(rowData ? "/api/Event/UpdateEvent" : "/api/Event/AddEvent", {
      method: "POST",
      data: formData,
    })
      .then((response) => {
        setBtnLoading(false);
        notification["success"]({
          message: "Success",
          description:  `Event ${rowData ? "Updated" : "Created"} Successfully!`,
        });
        setDrawerVisibility(false);
        setRefetch((prev) => !prev);
      })
      .catch((err) => {
        setBtnLoading(false);
        notification.error({
          message: "Error",
          description: "Unable to Create Event",
        });
        console.log(err);
      });
  };

  let initialValues = {
    name: rowData && rowData.eventName,
    groupId: rowData && rowData.groupID,
    eventTypeId: rowData && rowData.eventTypeId,
    subdomain: rowData && rowData.subDomain,
    startDateTime:
      rowData && rowData.startDateTime && moment(rowData.startDateTime),
    endDateTime: rowData && rowData.endDateTime && moment(rowData.endDateTime),
  };

  return (
    <Form
      onFinish={handleEventCreate}
      requiredMark={false}
      initialValues={initialValues}
    >
      <Row gutter={[20, 20]}>
        <Col span={12}>
          <Form.Item
            rules={[{ required: true, message: "Please input a name!" }]}
            name="name"
            label="Name"
            labelCol={{ span: 24 }}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="groupId"
            label="Group"
            labelCol={{ span: 24 }}
            rules={[{ required: true, message: "Please select a group" }]}
          >
            <Select placeholder="Select Group">
              {allGroups &&
                allGroups.map((item, index) => (
                  <Option value={item.id} key={index}>
                    {item.name}
                  </Option>
                ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[20, 20]}>
        <Col span={12}>
          <Form.Item
            name="eventTypeId"
            label="Event Type"
            labelCol={{ span: 24 }}
            rules={[{ required: true, message: "Please select an event" }]}
          >
            <Select placeholder="Select Event Type">
              {allEventTypes &&
                allEventTypes.map((item, index) => (
                  <Option value={item.id} key={index}>
                    {item.eventName}
                  </Option>
                ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="subdomain"
            label="Sub Domain"
            labelCol={{ span: 24 }}
            rules={[{ required: true, message: "Please input subdomain!" }]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[20, 20]}>
        <Col span={12}>
          <Form.Item
            rules={[{ required: true, message: "Please select start data!" }]}
            name="startDateTime"
            label="Start Date"
            labelCol={{ span: 24 }}
          >
            <StyledDatePicker
              onChange={(date) =>
                date ? setStartDate(date) : setStartDate({})
              }
              disabledDate={disabledStartDate}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            rules={[{ required: true, message: "Please select end data!" }]}
            name="endDateTime"
            label="End Date"
            labelCol={{ span: 24 }}
          >
            <StyledDatePicker
              onChange={(date) => (date ? setEndDate(date) : setEndDate({}))}
              disabledDate={disabledEndDate}
            />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item>
        <Button type="primary" htmlType="submit" loading={btnLoading}>
          {rowData ? "Save" : "Create"}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default CreateEvent;
